import React from 'react'
import { Form, Radio as RadioAnt } from 'antd'
import { GetFieldDecoratorOptions, WrappedFormUtils } from 'antd/lib/form/Form'
import { TextType, UIDirection, UISizes, UITypes } from 'LibNeo'
import { Primitive } from 'LibNeo/models/Radio'
import { Icon, RadioCaption, RadioLabel, RadioStyle, RadioTooltip, RadioWrapper } from './styled'

export type RadioOptionType<T> = {
	label?: string | JSX.Element
	value: T
	key: string
	disabled?: boolean
	tooltip?: string
	description?: string | JSX.Element
}

export interface RadioProps<T> {
	name?: string
	disabled?: boolean
	getFieldDecorator?: WrappedFormUtils['getFieldDecorator']
	options?: RadioOptionType<T>[]
	fieldOptions?: GetFieldDecoratorOptions
	onChange?: (v: T) => void
	direction?: UIDirection
	initialValue?: T
	form?: WrappedFormUtils
	value?: T
	fullWidth?: boolean
	className?: string
}

export const RadioComponent = <T extends Primitive>({
	disabled = false, // гарантирует появление атрибута data-qa-disabled, ввиду типа boolean | undef
	form,
	name,
	onChange,
	fieldOptions,
	options = [],
	direction = UIDirection.VERTICAL,
	value,
	fullWidth,
	className,
}: RadioProps<T>) => {
	const getRadio = () => {
		const switcher = options.map((item) => (
			<RadioWrapper>
				<RadioAnt key={item.key} value={item.value} disabled={item.disabled || disabled}>
					<RadioLabel disabled={item.disabled || disabled}>
						<RadioTooltip>
							{item.label}
							{Boolean(item?.tooltip) && (
								<Icon
									type={UITypes.PASSIVE}
									name="question-mark-circle-outline"
									tooltip={item?.tooltip}
									size={UISizes.SMALL}
								/>
							)}
						</RadioTooltip>
					</RadioLabel>
				</RadioAnt>
				{item?.description && (
					<RadioCaption type={TextType.CAPTION} colorIndex={5}>
						{item?.description}
					</RadioCaption>
				)}
			</RadioWrapper>
		))
		if (form) {
			return (
				<Form.Item data-qa-disabled={disabled}>
					{form.getFieldDecorator(name, { ...fieldOptions })(
						<RadioStyle
							disabled={disabled}
							vertical={direction === UIDirection.VERTICAL}
							horizontal={direction === UIDirection.HORIZONTAL}
							fullwidth={fullWidth && direction === UIDirection.HORIZONTAL}
							className={className}
							onChange={(e) => onChange?.(e.target.value)}
						>
							{switcher}
						</RadioStyle>
					)}
				</Form.Item>
			)
		}
		return (
			<RadioStyle
				className={className}
				vertical={direction === UIDirection.VERTICAL}
				horizontal={direction === UIDirection.HORIZONTAL}
				fullwidth={fullWidth && direction === UIDirection.HORIZONTAL}
				onChange={(e) => onChange(e.target.value)}
				value={value}
				disabled={disabled}
			>
				{switcher}
			</RadioStyle>
		)
	}

	return getRadio()
}
